import React from 'react'
import { AddressBookList } from '../../../Common'

export const AddressBook = () => {
  return <AddressBookList withEdit />
}
